import React from 'react';
import './Follows.css';
import imageFacebook from 'assets/img/Facebook_icon.svg';
import imageBandZone from 'assets/img/logo_bz.png';
import imageMail from 'assets/img/envelope-tiny.png';
import imageYT from 'assets/img/YouTube_social_white_circle.svg';
import imageSpotify from 'assets/img/Spotify_icon.svg';

const Follows = () => {
  return (
    <div className="follows">
      <p className="follows-header">
        Sledujte&nbsp;nás, pište&nbsp;na:
      </p>
      <div className="follows-icons">
        <a href="https://www.facebook.com/doktortriceratops/" target="_blank" rel="noopener noreferrer">
          <div className="follows-icon">
            <img src={imageFacebook} alt="Facebook" />
          </div>
        </a>
        <a href="https://www.youtube.com/user/DTRandy/videos" target="_blank" rel="noopener noreferrer">
          <div className="follows-icon">
            <img src={imageYT} alt="Youtube" />
          </div>
        </a>
        <a href="https://open.spotify.com/artist/65GBLk50PNYaz7Cuq8UpJk" target="_blank" rel="noopener noreferrer">
          <div className="follows-icon">
            <img src={imageSpotify} alt="Spotify" />
          </div>
        </a>
        <a href="mailto:randy@volny.cz">
          <div className="follows-icon">
            <img src={imageMail} alt="eMail" />
          </div>
        </a>
        <a href="https://bandzone.cz/doktortriceratops" target="_blank" rel="noopener noreferrer">
          <div className="follows-icon">
            <img src={imageBandZone} alt="BandZone" />
          </div>
        </a>
      </div>
    </div>
  );
}

export default Follows;